import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventData: {
    additional_info: {
      boarding_from: "",
      conference_location: "",
      destination_to: "",
      hotel_requirement: "",
      number_of_nights: "",
      number_of_persons: "",
      service_required: [],
    },
    agency: [],
    quiz_id: '',
    is_premium: '',
    business: "",
    coordinator_name: "",
    coordinator_name_2: "",
    coordinator_name_3: "",
    current_step: "",
    documents: [],
    email: "",
    email_2: "",
    email_3: "",
    employee: [],
    estimated_budget: "",
    event_location: "",
    event_name: "",
    from_date: "",
    metadata: {},
    other_requirements: "",
    phone: "",
    phone_2: "",
    phone_3: "",
    status: "",
    to_date: "",
    type: "",
    workflow_id: "",
  },
};

export const createEventSlice = createSlice({
  name: "createEvent",
  initialState: initialState,
  reducers: {
    setEventData: (state, action) => {
      const { value, name } = action.payload;
      if (
        name === "boarding_from" ||
        name === "conference_location" ||
        name === "destination_to" ||
        name === "hotel_requirement" ||
        name === "number_of_nights" ||
        name === "number_of_persons" ||
        name === "service_required"
      )
        return {
          ...state,
          eventData: {
            ...state.eventData,
            additional_info: {
              ...state.eventData.additional_info,
              [name]: value,
            },
          },
        };
      else
        return {
          ...state,
          eventData: {
            ...state.eventData,
            [name]: value,
          },
        };
    },
    reset: () => initialState,
  },
});

export const { setEventData, reset } = createEventSlice.actions;
export default createEventSlice.reducer;
